import { useCallback, useState } from 'react';
import { confirmUpload, putToStorage, requestUpload, type UploadView } from '../uploads.api';

export type UploadState =
  | { status: 'idle' }
  | { status: 'uploading'; progress: number }
  | { status: 'confirming' }
  | { status: 'done'; upload: UploadView }
  | { status: 'failed'; error: string };

/** One file's presign → upload → confirm state machine, for FileUpload's customRequest. */
export function useUpload(entityType: string, entityId: string) {
  const [state, setState] = useState<UploadState>({ status: 'idle' });

  const start = useCallback(
    async (file: File) => {
      setState({ status: 'uploading', progress: 0 });
      try {
        const presigned = await requestUpload(entityType, entityId, file);
        await putToStorage(presigned, file, (progress) => setState({ status: 'uploading', progress }));
        setState({ status: 'confirming' });
        const upload = await confirmUpload(presigned.uploadId);
        setState({ status: 'done', upload });
      } catch (err) {
        setState({ status: 'failed', error: err instanceof Error ? err.message : 'Upload failed' });
      }
    },
    [entityType, entityId],
  );

  return { state, start };
}
